import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { UseHrApp } from "../utils/context";
import PositionedSnackbar from "./snackbar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
};

const initialValues = {
  oldPassword: "",
  newPassword: "",
  confirmNewPassword: "",
};

const validateForm = (values) => {
  const errors = {};

  if (!values.oldPassword) {
    errors.oldPassword = "Required";
  }

  if (!values.newPassword) {
    errors.newPassword = "Required";
  }

  if (!values.confirmNewPassword) {
    errors.confirmNewPassword = "Required";
  } else if (values.confirmNewPassword !== values.newPassword) {
    errors.confirmNewPassword = "Passwords do not match";
  }

  return errors;
};



export default function EditPassword() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {
    Emtoken,
  
    setshow,
    settext,
    setseverity,
    show,
    text,
    severity,
  } = UseHrApp();

  async function UpdatePassword(oldPassword, newPassword) {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/employees/employee/edit",
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${Emtoken}`,
        },
        data: {
          oldPassword: oldPassword,
          password: newPassword,
        },
      });
      if (res?.data?.status) {
        settext(`Password updated successfully  `);
        setseverity("success");
        setshow(true);
      }
    } catch (error) {
      settext(`Password update failed `);
      setseverity("error");
      setshow(true);
    }
  }

  return (
    <div>
      <button
        onClick={handleOpen}
        className="p-3 px-4 mt-[1em] text-white bg-[#b06bde]"
      >
        Edit
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Change Password
          </Typography>
          <Formik
            initialValues={initialValues}
            validate={validateForm}
            onSubmit={(values) => {
              // Handle form submission logic here

              console.log(values);
              UpdatePassword(values.oldPassword, values.newPassword);
              handleClose();
            }}
          >
            <Form className="flex flex-col gap-[1.7em] mt-6">
              <div>
                <Field
                  name="oldPassword"
                  as={TextField}
                  label="Old Password"
                  type="password"
                  fullWidth
                />
                <ErrorMessage
                  name="oldPassword"
                  component="div"
                  className="text-red-600" // Apply custom style to the error message
                />
              </div>
              <div>
                <Field
                  name="newPassword"
                  as={TextField}
                  label="New Password"
                  type="password"
                  fullWidth
                />
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-red-600" // Apply custom style to the error message
                />
              </div>
              <div>
                <Field
                  name="confirmNewPassword"
                  as={TextField}
                  label="Confirm New Password"
                  type="password"
                  fullWidth
                />
                <ErrorMessage
                  name="confirmNewPassword"
                  component="div"
                  className="text-red-600" // Apply custom style to the error message
                />
              </div>
              <button
                type="submit"
                className="p-3 px-4 mt-[1em] text-white bg-[#b06bde]"
              >
                Update
              </button>
            </Form>
          </Formik>
        </Box>
      </Modal>
      <PositionedSnackbar
        value={show}
        setshow={setshow}
        text={text}
        severity={severity}
      />
    </div>
  );
}
